<template>
  <div class="t-calendar-item__data-item" :class="overbookedClass">
    {{ remaining }} <span v-if="priorityBookingCount"> (優先 {{priorityBookingCount}})</span>
  </div>
</template>

<script>
export default {
  props: {
    rooms: Array,
    bookings: Array
  },
  computed: {
    remaining () {
      const roomCount = this.rooms.length
      const bookingCount = this.bookings.length

      const remaining = roomCount - bookingCount
      return remaining
    },
    priorityBookingCount () {
      return this.bookings.filter(b => b.priorityBooking).length
    },
    overbookedClass () {
      if (this.remaining < 0) return 'overbooked'
      // check if any of the individual room is overbooked
      const roomIds = new Set()
      for (const booking of this.bookings) {
        const id = booking.roomId
        if (roomIds.has(id)) {
          return 'room-overbooked'
        }
        roomIds.add(id)
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.overbooked {
  background-color: red;
  color: #fff !important
}
.room-overbooked {
  background-color: yellow;
  color: #000 !important
}
</style>
